import request from '@/utils/request'

// 消息：查询用户的系统消息
export function sysUserMsg() {
    return request({
        url: '/manager/sysMsgsCenter/userMsg',
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 消息：查询用户的账号消息
export function userMsg(bizGroup) {
    return request({
        url: `/msgs/msgsCenterInfo/userMsg?bizGroup=${bizGroup}`,
        method: 'get',
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 消息：分页查询用户的系统消息
export function sysMsgPage(data) {
    return request({
        url: '/manager/sysMsgsCenter/page',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 消息：分页查询用户的账号消息
    export function msgPage(data) {
    return request({
        url: '/msgs/msgsCenterInfo/page',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    });
}
// 消息：分页查询用户的系统消息详情
export function sysMsgdetails(id, isRead) {
    return request({
        url: `/manager/sysMsgsCenter/details/${id}/${isRead}`,
        method: 'get'
    }).then((res) => {
        return Promise.resolve(res);
    });
}

export function newVersion(id, isRead) {
    return request.get(`/manager/sysMsgsCenter/getStationMsgsCenterId/${id}/${isRead}`)
      .then((res) => {
          return Promise.resolve(res);
      })
}

// 消息：分页查询用户的账号消息详情
export function msgdetails(id, isRead) {
    return request({
        url: `/msgs/msgsCenterInfo/${id}/${isRead}`,
        method: 'get'
    }).then((res) => {
        return Promise.resolve(res);
    });
}

// 消息：分页查询用户的账号消息详情
export function finalPayRecordDate() {
    return request({
        url: '/defaults/payRecord/finalPayRecordDate',
        method: 'get'
    }).then((res) => {
        return Promise.resolve(res);
    });
}

export function getInventoryDetail(centerId, isRead) {
    return request.get(`/msgs/msgsCenterInfo/saleInventoryWarnDetail/${centerId}/${isRead}`)
      .then((res) => {
          return Promise.resolve(res);
      })
}

export function getNRDetail(centerId, isRead) {
    return request.get(`/msgs/msgsCenterInfo/reviewWarnDetail/${centerId}/${isRead}`)
      .then((res) => {
          return Promise.resolve(res);
      })
}

export function batchMarkSysMessage(ids) {
    return request.get(`/manager/sysMsgsCenter/mark?msgCenterIds[]=${ids}`)
      .then((res) => {
          return Promise.resolve(res);
      })
}

export function batchMarkAccountMessage(ids) {
    return request.get(`/msgs/msgsCenterInfo/mark?msgCenterIds[]=${ids}`)
      .then((res) => {
          return Promise.resolve(res);
      })
}

export function getMessageSetting() {
    return request.get(`/msgs/msgsCenterInfoReceiveFilter`)
      .then((res) => {
          return Promise.resolve(res.data);
      })
}

export function updateMessageSetting(params) {
    return request.put(`/msgs/msgsCenterInfoReceiveFilter`, params)
      .then((res) => {
          return Promise.resolve(res);
      })
}
// 跟卖监控预警
export function getofferMonitorWarnDetail(centerId, isRead) {
    return request.get(`/msgs/msgsCenterInfo/offerMonitorWarnDetail/${centerId}/${isRead}`)
      .then((res) => {
          return Promise.resolve(res);
      })
}
//强制公共是否显示
export function getVersionBoot() {
    return request.get(`/base/customConfig/getVersionBoot`)
      .then((res) => {
          return Promise.resolve(res.data);
      })
}
//强制公共取消显示
export function saveOrUpdate(data) {
    return request({
        url: '/base/customConfig/saveOrUpdate',
        method: 'post',
        data
    }).then((res) => {
        return Promise.resolve(res);
    })
}